import React, { useState, useEffect, useRef } from 'react'

import * as Modal from '_components/modal/generic-modal'
import { TextField, Grid, InputLabel } from '@mui/material'
import useStyles from './styles'

export function AdditionalWarrantyMonthsModal({
  budget,
  openModal,
  setOpenModal,
  handleInputChange,
  onSaveBudget = () => {},
  closeMainModal = () => {},
}) {
  const styles = useStyles()
  const [error, setError] = useState(false)
  const originalValueRef = useRef('')
  const [value, setValue] = useState('')

  const handleChange = event => {
    const inputValue = event.target.value

    if (!/^\d*$/.test(inputValue)) {
      return
    }

    setError(false)
    setValue(inputValue)

    handleInputChange({
      target: {
        name: 'additionalWarrantyMonths',
        value: inputValue === '' ? '' : Number(inputValue),
      },
    })
  }

  const handleSave = () => {
    if (!value.trim()) {
      setError(true)
      return
    }

    setOpenModal(false)
    closeMainModal()
    onSaveBudget()
  }

  const handleCancel = () => {
    handleInputChange({
      target: {
        name: 'additionalWarrantyMonths',
        value: originalValueRef.current === '' ? '' : Number(originalValueRef.current),
      },
    })
    setOpenModal(false)
  }

  useEffect(() => {
    if (openModal) {
      const currentValue = budget?.additionalWarrantyMonths ?? ''

      originalValueRef.current = currentValue
      setValue(String(currentValue))
      setError(false)
    }
  }, [openModal])

  return (
    <Modal.Root className={styles.root} open={openModal} onClose={() => setOpenModal(false)}>
      <Modal.TitleModal title="Informações complementares" />
      <Modal.Content className={styles.dialogContent}>
        <Grid className={styles.warrantyMonthsContainer}>
          <InputLabel
            variant="body2"
            id="additionalWarrantyMonths"
            style={{ color: error ? '#C90000' : null }}
            className={styles.label}
          >
            Quantos meses de garantia estendida?<span className={styles.required}>*</span>
          </InputLabel>

          <TextField
            className={styles.warrantyMonths}
            name="additionalWarrantyMonths"
            value={value}
            variant="outlined"
            fullWidth
            onChange={handleChange}
            error={error}
            helperText={error ? 'Esse campo é obrigatório' : ''}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Modal.ButtonRed onClick={handleCancel}>Cancelar</Modal.ButtonRed>
        <Modal.ButtonFullBlue onClick={handleSave}>Salvar</Modal.ButtonFullBlue>
      </Modal.Actions>
    </Modal.Root>
  )
}
